import React, {
  useMemo,
  useCallback,
  useRef,
  useEffect,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Edit, Visibility } from '@material-ui/icons';
import { includes, isArray } from 'lodash';
import { parseISO, format } from 'date-fns';

import api from '~/services/api';
import { t, number } from '~/helpers';
import { UnidataTable, Modal } from '~/components';
import {
  deleteVeiculo,
  findVeiculo,
  recordFiltering,
} from '~/store/modules/veiculo/actions';
import { resetValues } from '~/store/modules/vehicleRegistration/actions';
import { ADM, GFE, GFO, GFU } from '~/constants/perfil';

import FormVehicle from './FormVehicle';
import DetailVehicle from './Detalhe';

export default function VeiculoList() {
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const detailRef = useRef(null);

  const [rendering, setRendering] = useState(false);

  const data = useSelector((state) => state.veiculo);

  const { glousuariotipo, gloperfilid } = useSelector(
    (state) => state.user.profile
  );

  const optionsActive = useMemo(
    () => [
      { label: 'Em uso', value: 'Em uso' },
      { label: 'Manut/Acidentado', value: 'Manut/Acidentado' },
      { label: 'Impedimento DETRAN', value: 'Impedimento DETRAN' },
      { label: 'Fora de uso', value: 'Fora de uso' },
      { label: 'Inativo', value: 'Inativo' },
      {
        label: 'Abastec anterior pendente SIAD',
        value: 'Abastec anterior pendente SIAD',
      },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'veic_placa_aux',
        label: 'Veículo',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'orga_codigo',
        label: 'Código Órgão',
        align: 'right',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'unid_codigo',
        label: 'Código Unidade',
        align: 'right',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'veic_municipio',
        label: 'Município',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'veic_status',
        label: 'Status',
        formatted: (value) =>
          optionsActive.find((s) => s.label === value).value,
        filter: { type: 'select', options: optionsActive },
      },
      {
        id: 'orga_nome',
        label: 'Descrição Órgão',
      },
      {
        id: 'unid_nome',
        label: 'Descrição Unidade',
      },
      {
        id: 'vemm_codigo',
        label: 'Código Modelo',
        align: 'right',
      },
      {
        id: 'vemm_nome',
        label: 'Marca / Modelo',
      },
      {
        id: 'veic_ano_modelo',
        label: 'Ano Modelo',
        align: 'right',
      },
      {
        id: 'veic_ano_fabricacao',
        label: 'Ano Fabricação',
        align: 'right',
      },
      {
        id: 'veic_renavam',
        label: 'RENAVAM',
        align: 'right',
      },
      {
        id: 'veic_volume_tanque',
        label: 'Volume Tanque',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'veic_totalizador',
        label: 'Totalizador',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'veic_totalizador_referencia',
        label: 'Totalizador Referência',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'veic_possui_transp',
        label: 'Possui Transponder',
        align: 'center',
      },
      {
        id: 'veic_leituracontinuatransp',
        label: 'Leitura Contínua Transponder',
        align: 'center',
      },
      {
        id: 'veic_abastscadaconfirm',
        label: 'Abastecimento entre Confirmação',
      },
      {
        id: 'veic_limite_sem_dvec',
        label: 'Data Limite Sem DVEC',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy'),
      },
      {
        id: 'veic_afericao_dvec',
        label: 'Aferição DVEC',
        align: 'center',
      },
      {
        id: 'veic_tag1',
        label: 'Transp 01',
      },
      {
        id: 'veic_tag2',
        label: 'Transp 02',
      },
      {
        id: 'veic_tag3',
        label: 'Transp 03',
      },
      {
        id: 'veic_possui_dvec',
        label: 'Possui DVEC',
        align: 'center',
      },
      {
        id: 'veic_idxbee',
        label: 'DVEC',
      },
      {
        id: 'veic_transacoes',
        label: 'Transações',
        align: 'right',
      },
      {
        id: 'veic_saldo_transacoes',
        label: 'Saldo Transações',
        align: 'right',
      },
      {
        id: 'veic_tipo_transacao',
        label: 'Tipo Transação',
        align: 'right',
      },
      {
        id: 'veic_intervalo',
        label: 'Intervalo',
        align: 'right',
      },
      {
        id: 'veic_tipo_intervalo',
        label: 'Tipo Intervalo',
        align: 'right',
      },
      {
        id: 'veic_bloqueado',
        label: 'Veículo Bloqueado',
        align: 'right',
      },
      {
        id: 'veic_placa',
        label: 'Placa',
      },
      glousuariotipo === ADM
        ? {
          id: 'veic_bloqueio_inadimplencia_str',
          label: 'Status Inadimplência',
        }
        : {},
      includes([ADM, GFE, GFO, GFU], glousuariotipo)
        ? {
          id: 'veic_hodentrecadaconfirm',
          label: 'Hodômetro Confirmado',
          formatted: (value) => number(value, 1),
        }
        : {},
    ],
    [optionsActive, ADM, GFE, GFO, GFU]
  );


  const handleGetAPIVehicle = useCallback(async (id) => {
    try {
      await api.get(`veiculo/completo/${id}`).then(({ data }) => {
        modalRef.current.handleOpenModal({
          data: data.veiculo,
          diasLiberacao: data.diasLiberacao,
          datasBloqueio: data.datasBloqueio,
          municipios: data.municipios,
          cotas: data.cotas,
          municipioprodutos: data.municipioprodutos,
        });
      });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const buttons = useMemo(() => {
    if (includes([ADM, GFU, GFO, GFE], gloperfilid)) {
      return [
        {
          title: 'Alterar',
          action: (value) => handleGetAPIVehicle(value.veic_placa),
          icon: <Edit />,
        },
        {
          title: 'Detalhes',
          action: (value) => detailRef.current.handleOpenModal({ data: value }),
          icon: <Visibility />,
        },
      ];
    }

    return [
      {
        title: 'Detalhes',
        action: (value) => detailRef.current.handleOpenModal({ data: value }),
        icon: <Visibility />,
      },
    ];
  }, [gloperfilid]);

  const buttonsDetail = useMemo(
    () => [
      {
        label: 'Fechar',
        color: 'secondary',
        variant: 'outlined',
        callback: () => detailRef.current.handleCloseModal(),
        autoFocus: true,
      },
    ],
    []
  );


  const handleAfterClosingModal = useCallback(() => {
    setRendering(true);
    dispatch(resetValues());
  }, [data.params]);

  useEffect(() => {
    if (rendering) {
      setRendering(false);
      dispatch(recordFiltering(data.params));
    }
  }, [rendering, data.params]);

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="veic_placa_aux ASC"
        fixed
        header={header}
        redux={data}
        actions={buttons}
        read={recordFiltering}
        remove={deleteVeiculo}
        find={findVeiculo}
        create={false}
        update={false}
        detach="veic_placa_aux"
        keys="veic_placa"
        view="VW_VEICULO"
        reportTitle="Cadastro de Veículo"
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        title="Cadastro de Veículo"
        maxWidth="md"
        fullScreen={window.innerWidth <= 425}
        component={FormVehicle}
        onClose={handleAfterClosingModal}
      />

      <Modal
        disableBackdropClick
        disableEscapeKeyDown
        ref={detailRef}
        title="Produtos do Veículo"
        maxWidth="xs"
        fullScreen={window.innerWidth <= 425}
        component={DetailVehicle}
        actions={buttonsDetail}
      />
    </>
  );
}
